import { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { Input } from "../../../../components";
import { StoreInputWrapper } from "./styled";

const StoreInput = ({
  id,
  initialValue,
  placeholder,
  errors = [],
  disabled,
  onChange = () => {}
}) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    onChange({ key: id, value });
  }, [value]);

  return (
    <StoreInputWrapper width={"100%"}>
      <Input
        id={id}
        value={value}
        setValue={setValue}
        hasError={errors.includes(id)}
        placeholder={placeholder}
        disabled={disabled}
        isSmall
      />
    </StoreInputWrapper>
  );
};

StoreInput.propTypes = {
  id: PropTypes.string.isRequired,
  initialValue: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

export default StoreInput;
